/* Show a way to shop if the external bundle widget returns no wine cards. */
(() => {
  const root = document.getElementById('wine_build_box');
  const fallback = document.querySelector('[data-yours-bundle-fallback]');
  if (!root || !fallback) return;
  let timedOut = false;
  function update() {
    const hasProducts = Boolean(root.querySelector('.th_pb_cb_p_grid_column'));
    const hasLoaded = Boolean(root.querySelector('.th_pb_cb_title'));
    fallback.hidden = hasProducts || !(hasLoaded || timedOut);
  }
  new MutationObserver(update).observe(root, { childList: true, subtree: true });
  setTimeout(() => { timedOut = true; update(); }, 12000);
  update();
})();
